import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useSupabaseAuth } from "../../hooks/auth/useSupabaseAuth";
import DashboardTabs from "../dashboard/DashboardTabs";
import LoadingSpinner from "../LoadingSpinner";
import ClaimBusinessWizard from "../dashboard/ClaimBusinessWizard";
import { ActiveBusinessProvider, useActiveBusiness } from "../../contexts/ActiveBusinessContext";

function DashboardContent() {
  const navigate = useNavigate();
  const { user, isLoaded: userLoaded, signOut } = useSupabaseAuth();
  const { activeProfile: profile, profileLoading, profileError, reloadActiveProfile } = useActiveBusiness();

  useEffect(() => {
    if (userLoaded && !user) {
      navigate('/login');
    }
  }, [user, userLoaded, navigate]);

  useEffect(() => {
    if (profileError) {
      console.error('Dashboard error:', profileError);
      toast.error('Failed to load dashboard. Please try again.');
    }
  }, [profileError]);

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Sign out error:', error);
      toast.error('Failed to sign out. Please try again.');
    }
  };

  if (!userLoaded || profileLoading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return null;
  }

  // If user has no profile/business, show the claim wizard
  if (!profile) {
    return (
      <div className="container mx-auto p-4">
        <div className="flex justify-end items-center mb-4">
          <button
            className="btn btn-outline"
            onClick={handleSignOut}
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </button>
        </div>
        <ClaimBusinessWizard onComplete={reloadActiveProfile} />
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Dashboard</h1>
          <p className="text-base-content/60">{profile.company_name || 'Complete your profile'}</p>
        </div>
        <div className="flex items-center gap-4">
          <Link to="/" className="btn btn-outline">
            <Home className="w-4 h-4 mr-2" />
            Home
          </Link>
          <button
            className="btn btn-outline"
            onClick={handleSignOut}
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </button>
        </div>
      </div>
      <DashboardTabs />
    </div>
  );
}

export default function LocksmithDashboard() {
  return (
    <ActiveBusinessProvider>
      <DashboardContent />
    </ActiveBusinessProvider>
  );
}
